import Mobiles_HSI_QI341 from './icon-images/Mobiles_HSI_QI341.png';
import Mobiles_HSI_QI341_HS from './icon-images/Mobiles_HSI_QI341_HS.png';
import Mobiles_HSI_QI442 from './icon-images/Mobiles_HSI_QI442.png';
import Mobiles_HSI_QI442_HS_CC_1 from './icon-images/Mobiles_HSI_QI442_HS_CC_1.png';
import Mobiles_HSI_QI442_HS_CC_2 from './icon-images/Mobiles_HSI_QI442_HS_CC_2.png';
import Mobiles_HSI_QI442_HS_OC_2 from './icon-images/Mobiles_HSI_QI442_HS_OC_2.png';
import Mobiles_HSI_QI442_HS_OC_3 from './icon-images/Mobiles_HSI_QI442_HS_OC_3.png';
import Mobiles_HSI_QI353 from './icon-images/Mobiles_HSI_QI353.png';
import Mobiles_HSI_QI353_HS_CC_1 from './icon-images/Mobiles_HSI_QI353_HS_CC_1.png';
import Mobiles_HSI_QI353_HS_CC_2 from './icon-images/Mobiles_HSI_QI353_HS_CC_2.png';
import Mobiles_HSI_QI353_HS_OC_2 from './icon-images/Mobiles_HSI_QI353_HS_OC_2.png';
import Mobiles_HSI_QI353_HS_OC_3 from './icon-images/Mobiles_HSI_QI353_HS_OC_3.png';
import Mobiles_HSI_UI310_plus from './icon-images/Mobiles_HSI_UI310+.png';

export const getImageMobileHSI = (model: string, configKey: number) => {
  if (model === 'QI341') {
    if (configKey <= 2) {
      return Mobiles_HSI_QI341;
    } else {
      return Mobiles_HSI_QI341_HS;
    }
  } else if (model === 'QI353') {
    if (configKey <= 2) {
      return Mobiles_HSI_QI353;
    } else if (configKey === 3 || configKey === 5 || configKey === 7) {
      return Mobiles_HSI_QI353_HS_OC_2;
    } else if (configKey === 4 || configKey === 6 || configKey === 8) {
      return Mobiles_HSI_QI353_HS_OC_3;
    } else if (configKey === 9 || configKey === 11 || configKey === 1) {
      return Mobiles_HSI_QI353_HS_CC_1;
    } else {
      return Mobiles_HSI_QI353_HS_CC_2;
    }
  } else if (model === 'UI310+') {
    return Mobiles_HSI_UI310_plus;
  } else {
    if (configKey <= 2) {
      return Mobiles_HSI_QI442;
    } else if (configKey === 3 || configKey === 5 || configKey === 7) {
      return Mobiles_HSI_QI442_HS_OC_2;
    } else if (configKey === 4 || configKey === 6 || configKey === 8) {
      return Mobiles_HSI_QI442_HS_OC_3;
    } else if (configKey === 9 || configKey === 11 || configKey === 1) {
      return Mobiles_HSI_QI442_HS_CC_1;
    } else {
      return Mobiles_HSI_QI442_HS_CC_2;
    }
  }
};
